import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import StatusViewEditComponent from "../../components/statusViewEditComponent";
import { toast } from "react-toastify";
import DeleteModal from "../../../../../Components/Common/DeleteModal";

import {
  createProductStockTransactionReason,
  createProductStockTransactionReasonSuccess,
  deleteProductStockTransactionReason,
  deleteProductStockTransactionReasonSuccess,
  getProductStockTransactionReasonList,
  updateProductStockTransactionReason,
  updateProductStockTransactionReasonSuccess,
} from "../../../../../store/product/action";

export default function ProductStockTransactionReason() {
  const dispatch = useDispatch();
  const { productStockTransactionReasonListSuccessAPI } = useSelector(
    (state) => ({
      productStockTransactionReasonListSuccessAPI:
        state.ProductCrmIT.productStockTransactionReasonListSuccess
          ?.productstocktransactionreason_list,
    })
  );

  const [statusList, setStatusList] = useState([]);
  const [activeTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [statusFlag] = useState(false);
  const [createStatus, setCreateStatus] = useState({
    Name: "New Reason",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
    FlagActive: "0",
  });

  const handleCreateNewStatus = () => {
    dispatch(createProductStockTransactionReason([createStatus]));
  };

  useEffect(() => {
    let data = [];
    data = productStockTransactionReasonListSuccessAPI?.sort(
      (a, b) => b.Id - a.Id
    );
    setStatusList(data);
  }, [productStockTransactionReasonListSuccessAPI]);

  useEffect(() => {
    dispatch(getProductStockTransactionReasonList());
  }, []);

  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    dispatch(deleteProductStockTransactionReason([deleteStatus]));
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
      FlagActive: updateItemStatus?.FlagActive,
    };
    const delayUpdate = setTimeout(() => {
      dispatch(updateProductStockTransactionReason([updateNewStatus]));
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  const {
    createProductStockTransactionReasonSuccessAPI,
    updateProductStockTransactionReasonSuccessAPI,
    deleteProductStockTransactionReasonSuccessAPI,
  } = useSelector((state) => ({
    createProductStockTransactionReasonSuccessAPI:
      state.ProductCrmIT.createProductStockTransactionReasonSuccess,
    updateProductStockTransactionReasonSuccessAPI:
      state.ProductCrmIT.updateProductStockTransactionReasonSuccess,
    deleteProductStockTransactionReasonSuccessAPI:
      state.ProductCrmIT.deleteProductStockTransactionReasonSuccess,
  }));

  // Add New response
  useEffect(() => {
    if (isEmpty(createProductStockTransactionReasonSuccessAPI)) return;
    if (createProductStockTransactionReasonSuccessAPI?.status === 200) {
      toast.success(createProductStockTransactionReasonSuccessAPI?.message);
      dispatch(getProductStockTransactionReasonList());
    } else {
      toast.error(createProductStockTransactionReasonSuccessAPI?.message);
    }
    dispatch(createProductStockTransactionReasonSuccess([]));
  }, [createProductStockTransactionReasonSuccessAPI]);

  // Update response
  useEffect(() => {
    if (isEmpty(updateProductStockTransactionReasonSuccessAPI)) return;
    if (updateProductStockTransactionReasonSuccessAPI?.status === 200) {
      toast.success(updateProductStockTransactionReasonSuccessAPI?.message);
      dispatch(getProductStockTransactionReasonList());
    } else {
      toast.error(updateProductStockTransactionReasonSuccessAPI?.message);
    }
    dispatch(updateProductStockTransactionReasonSuccess([]));
  }, [updateProductStockTransactionReasonSuccessAPI]);

  // Delete response
  useEffect(() => {
    if (isEmpty(deleteProductStockTransactionReasonSuccessAPI)) return;
    if (deleteProductStockTransactionReasonSuccessAPI?.status === 200) {
      toast.success(deleteProductStockTransactionReasonSuccessAPI?.message);
      dispatch(getProductStockTransactionReasonList());
      setDeleteModal(false);
    } else {
      toast.error(deleteProductStockTransactionReasonSuccessAPI?.message);
    }
    dispatch(deleteProductStockTransactionReasonSuccess([]));
  }, [deleteProductStockTransactionReasonSuccessAPI]);

  return (
    <>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteStatus}
          onCloseClick={() => {
            setDeleteModal(false);
          }}
        />
      )}
      <Row className="row align-items-end mt-3"></Row>
      <Row>
        <Col lg={12}>
          <StatusViewEditComponent
            statusList={statusList}
            setStatusList={setStatusList}
            createStatus={createStatus}
            setCreateStatus={setCreateStatus}
            handleCreateNewStatus={handleCreateNewStatus}
            setDeleteStatus={setDeleteStatus}
            setDeleteModal={setDeleteModal}
            setUpdateItemStatus={setUpdateItemStatus}
            statusFlag={statusFlag}
          />
        </Col>
      </Row>
    </>
  );
}
